import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = await auth.ensureCurrentUser();

  return (
    user !== null ||
    router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    })
  );
};
